import { Box, Stack, Text, styled } from "@/theme/index";
import { Title } from "../styledComponents";

export const CSContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.2),
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  backgroundColor: "#F4F6FD",
  borderRadius: "12px",
  maxWidth: "288px",

  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
}));

export const CSHeader = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(1.5),
}));

export const CSOptions = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  gap: theme.spacing(1),
}));

export const CSIconBackground = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: 100,
  backgroundColor: theme.palette.primary.light,
  width: "59px",
  height: "59px",
  boxSizing: "border-box",
}));

export const CSOption = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode | string;
}) => {
  return (
    <Stack spacing={1} direction="row">
      <Box>{icon}</Box>
      <Stack spacing={1}>
        <Title>{title}</Title>
        <Text variant="body2" color="text.main">
          {description}
        </Text>
      </Stack>
    </Stack>
  );
};
